module.exports = __webpack_public_path__ + "img/logo_extra_candidat.9e481872.png";